import {withTranslation} from '@wix/yoshi-flow-editor'
import {isEditor} from '../../../../commons/selectors/environment'
import {getCardsPerRow, getCardMargins, isResponsive} from '../../../../commons/selectors/settings'
import {getEvents} from '../../selectors/events'
import {getComponentConfig} from '../../selectors/settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {Cards as CardsPresentation} from './cards'
import {CardsOwnProps, CardsStateProps} from './interfaces'

const mapRuntimeToProps = ({state, sdk}: AppProps): CardsStateProps => {
  const componentConfig = getComponentConfig(state)
  const events = getEvents(state)
  const responsive = isResponsive(getComponentConfig(state))

  return {
    events,
    columns: Math.min(getCardsPerRow(componentConfig), events.length),
    cardMargins: getCardMargins(componentConfig),
    editor: isEditor(state),
    responsive,
    resizeComponent: (width: number, onSuccess: () => void) => sdk?.Wix?.resizeComponent({width} as any, onSuccess),
    setHeight: (height: number) => sdk?.Wix?.setHeight(height),
  }
}

export const Cards = connect<CardsOwnProps, CardsStateProps>(mapRuntimeToProps)(withTranslation()(CardsPresentation))
export * from './interfaces'
